module.exports = __webpack_public_path__ + "assets/img/advantage-block-bg.cdb9da7d.jpg";